export enum ConditionName {
  MAX_CONCENTRATION = 'max_concentration',
  ALARM1 = 'measurement_alarm_1',
  ALARM2 = 'measurement_alarm_2',
}

export enum ConditionPrefix {
  MAX_CONCENTRATION = 'max_',
  ALARM1 = 'alarm1_',
  ALARM2 = 'alarm2_',
}

export const prefixToNewField: Record<ConditionPrefix, ConditionName> = {
  [ConditionPrefix.MAX_CONCENTRATION]: ConditionName.MAX_CONCENTRATION,
  [ConditionPrefix.ALARM1]: ConditionName.ALARM1,
  [ConditionPrefix.ALARM2]: ConditionName.ALARM2,
}
